export const CRUISES_FALLBACK_URL =
  'https://cruises.delta.com/?utm_meditum=partner_site_hp_sw&utm_source=dl-delta.com&utm_campaign=20240701-dl-sw&utm_content=cruises_hp';
export const _BLANK = '_blank';
export const NO_OPENER_NO_REFERRER = 'noopener,noreferrer';
export const CRUISES = 'cruises';
